import React from 'react';
import { ApolloProvider } from '@apollo/client';

import SingletonUserUtil from '../../utils/UserUtil';
import SingletonTokenUtil from '../../utils/TokenUtil';

import jwtDecode from 'jwt-decode';
import { HttpLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { ApolloClient } from '@apollo/client';
import { ApolloLink, Observable } from '@apollo/client';
import { ApolloCache, InMemoryCache } from '@apollo/client/cache';
import { TokenRefreshLink } from 'apollo-link-token-refresh';
import { useDispatch } from 'react-redux';
import { logoutUser, setUser } from '../../redux/actions/user';

const cache = new InMemoryCache({});

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable((observer) => {
      let handle;
      Promise.resolve(operation)
        .then((operation) => {
          const accessToken = SingletonTokenUtil.getToken();
          if (accessToken) {
            operation.setContext({
              headers: {
                authorization: accessToken,
              },
            });
          }
        })
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          });
        })
        .catch(observer.error.bind(observer));

      return () => {
        if (handle) handle.unsubscribe();
      };
    })
);

export default function (props) {
  const dispatch = useDispatch();
  const [isUserLoaded, setIsUserLoaded] = React.useState(false);

  React.useEffect(() => {
    const user = SingletonUserUtil.getUser();
    dispatch(setUser(user));
    setIsUserLoaded(true);
  }, [dispatch]);

  const client = new ApolloClient({
    cache,
    link: ApolloLink.from([
      new TokenRefreshLink({
        accessTokenField: 'accessToken',
        isTokenValidOrUndefined: async () => {
          const token = SingletonTokenUtil.getToken();

          if (!token) {
            return true;
          }

          try {
            const { exp } = jwtDecode(token);
            if (Date.now() >= exp * 1000) {
              return false;
            } else {
              return true;
            }
          } catch {
            return false;
          }
        },
        fetchAccessToken: () => {
          return fetch(`${window._env_.REACT_APP_SERVER}/auth/refreshToken`, {
            method: 'POST',
            credentials: 'include',
          });
        },
        handleFetch: (accessToken) => {
          SingletonTokenUtil.setToken(accessToken);
        },
        handleError: (err) => {
          dispatch(logoutUser());
          SingletonTokenUtil.clearToken();
        },
      }),
      onError(({ graphQLErrors, networkError }) => {
        console.log(
          `Error: /frontend/src/components/ApolloClient GQL:\n${JSON.stringify(graphQLErrors)}\nNetwork:\n${JSON.stringify(networkError)} `
        );
      }),
      requestLink,

      new HttpLink({
        uri: window._env_.REACT_APP_GRAPHQL_ENDPOINT,

        // uri: 'http://localhost:4000/graphql',
        credentials: 'include',
      }),
    ]),
  });

  if (isUserLoaded) {
    return <ApolloProvider client={client}>{props.children}</ApolloProvider>;
    //return null;
  } else {
    return (
      <div className='container'>
        <div className='spinner-border' role='status'>
          <span className='sr-only'>Loading...</span>
        </div>
      </div>
    );
  }
}
